import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core'
import { RouterLink } from '@angular/router'
import { ButtonModule } from 'primeng/button'
import { orangeLightBg, orangeDarkBg } from '../../../assets/designTokens/customTokens'

@Component({
	selector: 'app-link',
	imports: [ButtonModule, RouterLink],
	templateUrl: './link.html',
	styleUrl: './link.css',
})
export class Link implements OnInit {
	@Output() clicked = new EventEmitter<boolean>(false)

	@Input() type!: string
	@Input() label!: string
	@Input() routerLink!: string
	@Input() bgColor!: string
	@Input() disabled: boolean = false
	@Input() fluid: boolean = true
	@Input() icon: string = 'pi pi-arrow-right'

	designToken!: any

	ngOnInit(): void {
		if (this.bgColor === 'light') {
			this.designToken = orangeLightBg
		}

		if (this.bgColor === 'dark') {
			this.designToken = orangeDarkBg
		}
	}

	onClick(): void {
		if (!this.disabled) {
			this.clicked.emit(true)
		}
	}
}
